import service from '../Common'
import constants from '../../../settings/shared/constants'


const _service = (options) => {
  options.baseURL = constants.drsApi.base.url
  if (options.hasOwnProperty('headers')) {
    options.headers['api-token'] = getAPIToken()
  } else {
    options.headers = { 'api-token': getAPIToken() }
  }
  return service(options)
}

const _constructHeader = (storageId, rootFolder) => {
  let headerObj = {};
  if (storageId !== null && storageId !== undefined) {
    headerObj = {
      "storage-id": storageId,
      "root-folder": (rootFolder === null || rootFolder === undefined) ? '' : rootFolder
    }
  }
  return headerObj
}
const _constructStreamHeader = (storageId, rootFolder) => {
  let headerObj = {};
  if (storageId !== null && storageId !== undefined) {
    headerObj = {
      "storage-id": storageId,
      'content-type': 'application/octet-stream',
      "root-folder": (rootFolder === null || rootFolder === undefined) ? '' : rootFolder
    }
  }
  return headerObj
}

const getAPIToken = () => {
  let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
  return currentUser.apiToken
}


function rendering(fileName, storageId, rootFolder, objectParam, onErrorCallBack) {
  return _service({
    url: constants.drsApi.objects.renderObject,
    method: 'POST',
    data: {
      file_path: fileName,
      current_page: objectParam.currentPage,
      no_of_records: objectParam.pageRecords,
      delimiter: objectParam.delimiter,
      version: objectParam.version
    },
    headers: _constructHeader(storageId, rootFolder),
    onError: onErrorCallBack
  })
}



const DRSService = {
  rendering
}

export default DRSService;
